import { render, staticRenderFns } from "./timeAgo.vue?vue&type=template&id=7ba8795a&"
import script from "./timeAgo.vue?vue&type=script&lang=js&"
export * from "./timeAgo.vue?vue&type=script&lang=js&"
import style0 from "./timeAgo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "timeAgo.vue"
export default component.exports